import React from 'react';
import {FastField, FormikErrors} from 'formik';
import EditorSection from 'gui/components/editors/commons/editor/components/editorSection';
import {Grid} from '@material-ui/core';
import VoucherTypeSelector from './components/voucherTypeSelector';
import {MDBPopover, MDBPopoverBody} from 'mdbreact';
import {Unless} from 'react-if';
import FormikDateSelector from 'gui/components/formikDateSelector';
import FormikDescription from 'gui/components/formikDescription';
import {eVoucherTypes} from 'data/enums/products';
import {createSelector} from "redux-starter-kit";
import FormikFileInput from 'gui/components/formikFileInput/FormikFileInput';
import FormikTextField from 'gui/components/formikTextField/FormikTextField';
import EditorDocumentInputContainer from 'data/redux/containers/editorDocumentInputContainer';
import CompanyNameTypeSwitch from "./components/companyNameTypeSwitch";
import CustomFieldsTypeSwitch from "./components/customFieldsTypeSwitch";


export interface IVoucherDetails {
  type: eVoucherTypes;

}

interface IVoucherDetailsProps {
  values: IVoucherDetails;
  errors: FormikErrors<any>;
  setFieldValue: any;
  touched: any;
  productFieldHide?: any;
}

const typeSelector = createSelector(['productFieldHide.voucherDetails.type']);

const VoucherDetails = (props: IVoucherDetailsProps) => {
  const hideType = !!typeSelector(props);
  return (
    <EditorSection title="פרטי שובר">
      <Unless condition={hideType}>
        {() => <Grid item xs={12} sm={4}>
          <FastField
            component={VoucherTypeSelector}
            label="סוג השובר"
            name="type"/>
        </Grid>}
      </Unless>
      <Grid item xs={12} sm={hideType ? 6 : 4}>
        <CompanyNameTypeSwitch {...props}/>
      </Grid>
      <Grid item xs={12} sm={hideType ? 6 : 4}>
        <FastField
          component={FormikDateSelector}
          label="תאריך תפוגה"
          name="expiration"/>
      </Grid>
      <CustomFieldsTypeSwitch {...props}/>

      <Grid item xs={12} sm={6}>
        <FormikTextField
          label="שם פרטי של בעל השובר"
          name="firstName"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormikTextField
          label="שם משפחה של בעל השובר"
          name="lastName"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormikTextField
          label="קוד שובר"
          name="code"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <MDBPopover
          placement="top"
          popover
          clickable
          domElement={true}
        >
          <div>
            <FastField
              component={FormikFileInput}
              fileInputComponent={EditorDocumentInputContainer}
              label="העלה תמונה של השובר"
              name="files"
              onChange={(e) => {
                
                props.setFieldValue('image', e);
              }}
            />
          </div>
          <div>
            <MDBPopoverBody>
              התמונה צריכה להיות צילום ברור של האסמכתא שבידכם ולהכיל את כל פרטי השובר הנדרשים למימושו (כגון: מייל, קובץ,
              SMS, כרטיס וכו')
            </MDBPopoverBody>
          </div>
        </MDBPopover>
      </Grid>

      <Grid item xs={12}>
        <FormikDescription
          label="תאור השובר - זה המקום לתת כמה שיותר מידע על השובר כדי שיהיה ברור לקונים מה בדיוק אתם מציעים. מומלץ לציין בהערות את הערך הכספי במטבע המקורי."
          name="description"
          values={props.values}
        />
      </Grid>
      <Grid item xs={12} style={{marginTop: 20}}>
        <FormikDescription
          label="מימוש השובר - איך ניתן לממש את השובר ואם יש תנאים מסוימים שחשוב לדעת"
          name="conditions"
          values={props.values}
        />
      </Grid>

    </EditorSection>
  );
};

VoucherDetails.defaultProps = {
  values: {},
  errors: [],
  touched: {},
  forcedRoundTrip: false,
  setFieldValue: () => null,
};

export default React.memo(VoucherDetails);
